<template>


  <div class="animated fadeIn">


    <b-row>
      <b-col md="12">
        <b-card>

          <b-col md="8" style="margin-left: auto;margin-right: auto;">
                   <b-card-group>
                     <b-card>
                       <b-card-body>
                         <b-form v-on:submit.prevent="onSubmit">

                           <p class="text-muted">Select Account Type</p>


         <b-form-radio-group
           id="basicRadiosCustom"
           value="1"
           stacked>
           <div class="custom-control custom-radio">
             <input type="radio" name="type" id="Fabricator" class="custom-control-input" v-model="type" value="fabricator" required>
             <label class="custom-control-label" for="Fabricator">I am a stone Fabricator</label>
           </div>
           <div class="custom-control custom-radio">
             <input type="radio" name="type" id="Distributor" class="custom-control-input" v-model="type" value="distributor" checked>
             <label class="custom-control-label" for="Distributor">I am a slab Distributor</label>
           </div>

         </b-form-radio-group>
<hr>


<b-row>
  <b-col sm="6">
    <b-form-group>
      <label for="firstName">First Name</label>
      <b-form-input type="text" name="firstName" placeholder="First Name" v-model="firstName" required></b-form-input>
    </b-form-group>
  </b-col>
  <b-col sm="6">
    <b-form-group>
      <label for="lastName">Last Name</label>
      <b-form-input type="text" name="lastName" placeholder="Last Name" v-model="lastName" required></b-form-input>
    </b-form-group>
  </b-col>

</b-row>
<b-row>
  <b-col sm="12">
    <b-form-group>
      <label for="companyName">Company Name</label>
      <b-form-input type="text" name="companyName" placeholder="Company Name" v-model="companyName" required></b-form-input>
    </b-form-group>
  </b-col>


</b-row>

<b-row>
  <b-col sm="12">
    <b-form-group>
      <label for="address1">Address 1</label>
      <b-form-input type="text" name="address1" placeholder="Address 1" v-model="address1" required></b-form-input>
    </b-form-group>
  </b-col>


</b-row>
<b-row>
  <b-col sm="12">
    <b-form-group>
      <label for="address2">Address 2</label>
      <b-form-input type="text" name="address2" placeholder="Address 2" v-model="address2"></b-form-input>
    </b-form-group>
  </b-col>


</b-row>
<b-row>
         <b-col sm="4">
           <b-form-group>
             <label for="cvv">City</label>
             <b-form-input type="text" name="city" v-model="city" placeholder="City" required></b-form-input>
           </b-form-group>
         </b-col>
         <b-col sm="4">
           <b-form-group>
             <label for="state">State</label>
             <b-form-select name="state" v-model="state"
               :plain="true"
               :options="stateList">
             </b-form-select>
           </b-form-group>
         </b-col>
         <b-col sm="4">
           <b-form-group>
             <label for="zip">Zip</label>
             <b-form-input type="text" name="zip" v-model="zip" placeholder="Zip Code" required></b-form-input>
           </b-form-group>
         </b-col>
       </b-row>

       <b-row>
         <b-col sm="12">
           <b-form-group>
             <label for="phone">Phone</label>
             <b-form-input type="text" name="phone" placeholder="Phone" v-model="phone" required></b-form-input>
           </b-form-group>
         </b-col>


       </b-row>
       <b-row>
         <b-col sm="12">
           <b-form-group>
             <label for="fax">Fax</label>
             <b-form-input type="text" name="fax" placeholder="Fax" v-model="fax"></b-form-input>
           </b-form-group>
         </b-col>


       </b-row>
       <b-row>
         <b-col sm="12">
           <b-form-group>
             <label for="email">E-mail</label>
             <b-form-input type="text" name="email" placeholder="E-mail" v-model="username" required></b-form-input>
           </b-form-group>
         </b-col>


       </b-row>
       <b-row>
         <b-col sm="12">
           <b-form-group>
             <label for="website">Website</label>
             <b-form-input type="text" name="website" placeholder="Website" v-model="website"></b-form-input>
           </b-form-group>
         </b-col>


       </b-row>
       <b-row>
         <b-col sm="3">
           <b-form-group>
             <label for="year">Year Established</label>
             <b-form-input type="text" name="year" placeholder="Year" v-model="year" required></b-form-input>
           </b-form-group>
         </b-col>


       </b-row>

                           <b-row>
                             <b-col cols="12">
<div class="g-recaptcha" data-sitekey="6Lfp3mwUAAAAAHOmzl9X4LBW7FkI5UhwrImjmQac"></div>
 </b-col>

                             <b-col cols="12" style="margin-top:39px">
                               <p style="margin-bottom:20px;color:#282828">By signing up, you agree to our <a href="/terms" target="_blank">Terms , Data Policy and Cookies Policy</a>.</p>
                               <br>
                                <input type="submit" variant="primary" class="px-4 full btn btn-primary left" style="border: none;width: 100%;background:#1a478b !important" :disabled="disabled == 1 ? true : false" v-model="saveStatus" >
                             </b-col>

                           </b-row>

                         </b-form>
                       </b-card-body>
                     </b-card>


                   </b-card-group>
                 </b-col>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { Callout } from '@coreui/vue'

export default {
  name: 'dashboard',
  components: {
    Callout,

  },
  data: function () {
    return {
      selected: 'Month',
      type:'',
      // Must be an array reference!
      show: true,
      save: false,
      firstName: '',
      lastName: '',
      username: '',
      disabled: 0,
      companyName: '',
      saveStatus: 'Submit',
      status: '',
      type: '',
      address1:'',
      address2:'',
      city:'',
      state:'',
      zip:'',
      phone:'',
      fax:'',
      website:'',
      year:'',
      enabled: false,
      value: false,
      stateList:['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'USA', flag: 'us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago'
        },
        {
          avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
          country: { name: 'Brazil', flag: 'br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago'
        },
        {
          avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'India', flag: 'in' },
          usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
          activity: '1 hour ago'
        },
        {
          avatar: { url: 'img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'France', flag: 'fr' },
          usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'PayPal', icon: 'fa fa-paypal' },
          activity: 'Last month'
        },
        {
          avatar: { url: 'img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Spain', flag: 'es' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
          activity: 'Last week'
        },
        {
          avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Poland', flag: 'pl' },
          usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
          activity: 'Last week'
        }
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'User'
        },
        country: {
          label: 'Country',
          class: 'text-center'
        },
        usage: {
          label: 'Usage'
        },
        payment: {
          label: 'Payment method',
          class: 'text-center'
        },
        activity: {
          label: 'Activity'
        }
      }
    }
  },
  methods: {
    getType(){
      console.log(this.$route)
 var reportID=this.$route.fullPath.split('?')
 var reportID=reportID[1];
 this.name=reportID;
 console.log(reportID)

 if(reportID=='fab'){this.type='fabricator'}
  if(reportID=='dis'){this.type='distributor'}
    },
    onSubmit() {
      console.log('t')
        var vm = this;
        vm.disabled = (vm.disabled + 1) % 2
        vm.saveStatus = 'Connecting..'
        var data = {
            username: vm.username,
            firstName: vm.firstName,
            lastName: vm.lastName,
            companyName: vm.companyName,
            type:vm.type,
            address1:vm.address1,
            address2:vm.address2,
            city:vm.city,
            state:vm.state,
            zip:vm.zip,
            phone:vm.phone,
            fax:vm.fax,
            website:vm.website,
            year:vm.year,

        }

        this.$http.post('/addUser', data, {
            emulateJSON: true
        }).then(function(data, err) {
            // Success

            save: true,
            console.log(data.body)
            if(data.body.status=='success'){
            vm.saveStatus = 'Success'
          window.location='/signup-note?'+vm.firstName+'';
            setTimeout(function() {
                vm.saveStatus = 'Save'
                vm.disabled = (vm.disabled + 1) % 2
            }, 2500);
}else{
vm.saveStatus = data.body.status

setTimeout(function() {
vm.saveStatus = 'Submit'

vm.disabled = (vm.disabled + 1) % 2
}, 2500);
}

        }, function(data) {
            // Error
            save: true,
            console.log(data.body)
            vm.saveStatus = 'Error, User Not Saved'
            setTimeout(function() {
                vm.saveStatus = 'Submit'
                vm.disabled = (vm.disabled + 1) % 2
            }, 2500);
        });

    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  },
  mounted () {
    this.getType();
    let recaptchaScript = document.createElement('script')
 recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
 document.head.appendChild(recaptchaScript)
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  @media only screen and (min-width: 996px) {
.app-header .navbar-toggler{display:none}
  .sidebar {
    margin-left: -200px !important;
}
html:not([dir=rtl]) .sidebar-lg-show.sidebar-fixed .app-footer, html:not([dir=rtl]) .sidebar-lg-show.sidebar-fixed .main {
    margin-left: 0px;
}
}
.breadcrumb{
  background:#46617A;
  color:#fff;
  margin:0px;
}
.breadcrumb a{
      color: #AFEEEE;
}
.main .container-fluid {
    padding: 0;

}
.card{

    border-radius: 0;
    border: none;

}
.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    background-color: #BC8166;
    border-color: #fff;
    color: #fff;
}
.btn-primary {
  background-color: #BC8166;
  border-color: #fff;
  color: #fff;
}
</style>
